import { useAppStore } from '@store'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

export default function TemporaryOpenProject() {
  const { id } = useParams()
  const setStoreFromBack = useAppStore.use.setStoreFromBack()
  const setOBBS = useAppStore.use.setOBBScene()
  useEffect(() => {
    setStoreFromBack(Number(id), true)
    setOBBS()
  }, [])
  return <div></div>
}
